import React from 'react'
import { hotjar } from 'react-hotjar'
import { BrowserRouter as Router, Route, Switch, RouteComponentProps } from 'react-router-dom'
import Error from './pages/Error'
import Onboarding from './pages/Onboarding'
import Registration from './pages/Registration'
import AccountVerification from './pages/Registration/AccountVerification'
import PrivateRoute from './shared/helpers/private-route'

const App = () => {
  const [isFirm, setIsFirm] = React.useState(false)
  const renderAccountVerification = (props: RouteComponentProps) => <AccountVerification {...props} isFirm={isFirm} />
  const renderRegistration = ({ location, history }: RouteComponentProps) => (
    <Registration queryParamsWithSource={location.search.includes('source')} history={history} setIsFirm={ setIsFirm } />
  )

  hotjar.initialize(Number(process.env.REACT_APP_HJID), Number(process.env.REACT_APP_HJSV))

  return (
    <Router>
      <Switch>
        <Route exact path={['/', '/registration']} render={renderRegistration} />
        <Route exact path="/registration/verify/:email" render={renderAccountVerification} />
        <PrivateRoute exact path="/registration/onboarding" component={Onboarding} />
        <Route
          exact
          path="/registration/review"
          component={() => {
            window.location.href = process.env.REACT_APP_PARO_APP_URL + '/freelancer/apply/registration-review'
            return null
          }}
        />
        <Route component={Error} />
      </Switch>
    </Router>
  )
}

export default App
